import type { Address, GooglePlacesDetailsResponse } from '@frontend/api-types';

/**
 * Converts Google Places API result to your address schema format
 * @param placeDetail - The result from Google Places Detail API
 * @returns Formatted address object matching your schema
 */
export const convertGooglePlacesToAddressSchema = (
  placeDetail: GooglePlacesDetailsResponse,
): Omit<Address, 'alias'> => {
  const components = placeDetail.addressComponents;

  const findComponent = (types: string[]): GooglePlacesDetailsResponse['addressComponents'][number] | undefined =>
    components.find((component) => component.types.some((type) => types.includes(type)));

  const streetNumber = findComponent(['street_number']);
  const route = findComponent(['route']);
  const city = findComponent(['locality', 'administrative_area_level_2']);
  const state = findComponent(['administrative_area_level_1']);
  const country = findComponent(['country']);
  const postalCode = findComponent(['postal_code']);
  const subpremise = findComponent(['subpremise']);

  const line1 =
    streetNumber && route
      ? `${streetNumber.longText} ${route.longText}`
      : route
        ? route.longText
        : placeDetail.formattedAddress.split(',')[0] || placeDetail.formattedAddress;

  return {
    city: city?.longText || '',
    countryCode: country?.shortText || '',
    line1,
    line2: subpremise?.longText || '',
    postalCode: postalCode?.longText || '',
    stateCode: state?.shortText || '',
  };
};
